<div class="modal-overlay" (click)="onClose()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <ng-container *ngIf="loadingState$ | async as loadingState; else formView">
      <ng-container *ngIf="loadingState === 'loading'; else formView">
        <div class="loading-container">
          <div class="spinner"></div>
          <p>Creating workspace...</p>
        </div>
      </ng-container>
    </ng-container>

    <ng-template #formView>
      <div class="modal-header">
        <h3>New Workspace</h3>
        <button class="close-btn" (click)="onClose()">×</button>
      </div>

      <div class="modal-body">
        <div class="form-group">
          <label for="label">Name *</label>
          <input
            type="text"
            id="workspace-name"
            [(ngModel)]="workspaceName"
            autofocus
          />
        </div>
        <div class="form-group">
          <label for="label">Owner Email</label>
          <input
            type="email"
            id="workspace-email"
            [(ngModel)]="email"
            (keydown.enter)="onSubmit()"
          />
        </div>
      </div>

      <div class="modal-footer">
        <button
          class="primary"
          (click)="onSubmit()"
          [disabled]="!workspaceName.trim()"
        >
          Create
        </button>
      </div>
    </ng-template>
  </div>
</div>
